import Request from "../Request/Request";
import css from "./Track.module.css";

const Track = ({ onComplete, onTimeout, removeRequest, requests, statuses }) => {
  return (
    <div
      className={`${css.main} ${statuses.includes("server-processed") ? css.success : ""}`}
    >
      {requests
        .filter((request) => statuses.includes(request.status))
        .map((request) => (
          <Request
            key={request.id}
            request={request}
            onComplete={onComplete}
						onTimeout={onTimeout}
            selfDestruct={() => removeRequest(request)}
          />
        ))}
    </div>
  );
};

export default Track;
